import { PrescricaoType } from '_metronic/helpers/enums'
import { ItemPrescricao } from './itens'

/** Campo obrigatório que ainda falta num item. */
export type CampoPendente = 'posologia' | 'quantidade'

const vazio = (valor?: string) => !valor?.trim()

/**
 * O que falta para o item poder ser assinado: medicamento e fórmula pedem posologia e
 * quantidade. As quantidades do LME são pedidas ao gerar o LME, depois da assinatura.
 */
export const camposPendentes = (item: ItemPrescricao): CampoPendente[] => {
  switch (item.categoria) {
    case PrescricaoType.Medicamento:
    case PrescricaoType.Formula: {
      const faltam: CampoPendente[] = []
      if (vazio(item.posologia)) faltam.push('posologia')
      if (vazio(item.quantidade)) faltam.push('quantidade')
      return faltam
    }
    // Orientação só muda pelo modal, que já exige o texto; exame não tem campo obrigatório.
    case PrescricaoType.Orientacoes:
    case PrescricaoType.Exame:
      return []
  }
}

/** `id` do campo no DOM: as pendências da revisão levam o foco até ele. */
export const idDoCampo = (chave: string, campo: CampoPendente | 'instrucoes') => `${chave}-${campo}`

/** Primeiro campo do item, que recebe o foco quando ele é adicionado (orientação não tem campo). */
export const primeiroCampo = (item: ItemPrescricao): CampoPendente | 'instrucoes' | undefined => {
  switch (item.categoria) {
    case PrescricaoType.Exame:
      return 'instrucoes'
    case PrescricaoType.Orientacoes:
      return undefined
    default:
      return 'posologia'
  }
}
